import { render, staticRenderFns } from "./ListOrderCard.vue?vue&type=template&id=988cbcd6&scoped=true&"
import script from "./ListOrderCard.vue?vue&type=script&lang=js&"
export * from "./ListOrderCard.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/sass/style_custom.scss?vue&type=style&index=0&id=988cbcd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988cbcd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('988cbcd6')) {
      api.createRecord('988cbcd6', component.options)
    } else {
      api.reload('988cbcd6', component.options)
    }
    module.hot.accept("./ListOrderCard.vue?vue&type=template&id=988cbcd6&scoped=true&", function () {
      api.rerender('988cbcd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Listing/ListOrderCard.vue"
export default component.exports